export default __webpack_public_path__ + "static/media/Emblem of Ashur.9064a4d6.jpg";